<template>
  <header class="lg:hidden flex items-center justify-between bg-primary-800 text-white h-16 px-4 shadow-md sticky top-0 z-20">
    <span class="font-bold">OXO Admin</span>
    <button
      class="p-2 text-primary-300 hover:text-white transition-colors"
      aria-label="Ouvrir le menu"
      @click="toggle"
    >
      <font-awesome-icon :icon="['fas', 'bars']" />
    </button>
  </header>
</template>

<script setup lang="ts">
import { useSidebar } from '~/composables/useSidebar'

const { toggle } = useSidebar()
</script>
